export default "__VITE_ASSET__CsPtovcW__"